import CONSTANTS from '../../constants';

const state = {
    errors: {},
};

const mutations = {
    [CONSTANTS.MUTATIONS.PUSH_ERRORS](state, errorsObject) {
        console.log('MUTATIONS PUSH ERRORS');
        state.errors = errorsObject;
    },
    [CONSTANTS.MUTATIONS.CLEAR_ERRORS](state) {
        console.log('CLEAR_ERRORS()');
        state.errors = {};
    }
};

const getters = {
    getErrors: (state) => (fieldName) => {
        return state.errors[fieldName] || [];
    },
};

export default {
        namespaced: true,
        state,
        mutations,
        getters
    }



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/form-errors.js